<template>
  <main class="legal">
    <RichText :field="policy.primary.header" />
    <RichText
      v-if="policy.primary.policy"
      :field="policy.primary.policy"
      class="rich-text"
    />
    <div
      v-if="policy.primary.cookie_table"
      class="cookie-table"
      v-html="policy.primary.cookie_table"
    />
    <RichText
      v-if="policy.primary.policy_end"
      :field="policy.primary.policy_end"
      class="rich-text"
    />
  </main>
</template>
<script>
export default {
  props: {
    policy: {
      type: Object,
      default: undefined
    }
  }
};
</script>
<style lang="scss" scoped>
@import '../scss/base/colors';

::v-deep h1 {
  width: 100%;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px;
}
.rich-text {
  max-width: 1380px;
  margin: 0 auto;
  padding: 0 30px;

  ::v-deep p {
    color: $grey-2;
  }
  ::v-deep strong {
    color: $black;
  }

  &:nth-last-child(2) {
    margin-bottom: 100px;
  }
}

::v-deep .cookie-table {
  max-width: calc(23 * 60px);
  margin: 0 auto;
  padding: 0 30px;

  td,
  th {
    border: 1px solid $grey-2;
    padding: 5px;
  }
}
</style>
